import { Component, input } from '@angular/core';
import { BeforeAfter, SetupWizardPreviewStatus } from '@mira-avant/mtlibs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { Column } from '../../setup-wizard-dynamic-table/setup-wizard-dynamic-table';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

export const BEFORE_AFTER_STATUS_UPSERT_COLOR = '#8b5cf6';
export const BEFORE_AFTER_STATUS_NEW_COLOR = '#10b981';
export const BEFORE_AFTER_STATUS_CHANGED_COLOR = '#f59e0b';
export const BEFORE_AFTER_STATUS_UNCHANGED_COLOR = '#6b7280';
export const BEFORE_AFTER_STATUS_REMOVED_COLOR = '#ef4444';

export function makeStatusColumn<T>(upsertMode: boolean = false): Column {
	return {
		key: 'status',
		name: 'Status',
		sortDirections: ['ascend', 'descend', null],
		sortOrder: null,
		sortFn: (a: BeforeAfter<T>, b: BeforeAfter<T>): number => {
			const aHasAfter = !!a.after;
			const bHasAfter = !!b.after;

			if (aHasAfter && !bHasAfter) {
				return 1;
			}

			if (!aHasAfter && bHasAfter) {
				return -1;
			}

			return 0;
		},
		filterMultiple: true,
		filterOptions: [
			{ text: SetupWizardPreviewStatus.NEW, value: SetupWizardPreviewStatus.NEW },
			{ text: SetupWizardPreviewStatus.UPSERT, value: SetupWizardPreviewStatus.UPSERT },
			{ text: SetupWizardPreviewStatus.CHANGED, value: SetupWizardPreviewStatus.CHANGED },
			{ text: SetupWizardPreviewStatus.UNCHANGED, value: SetupWizardPreviewStatus.UNCHANGED },
		],
		filterFn: (value: string[], record: BeforeAfter<T>): boolean => {
			//New means after exists and before does not.
			//Changed means after exists and before exists.
			//Upsert means after exists and before does not, but upsertMode is true.
			//Unchanged means before exists and after does not.

			const hasAfter = !!record.after;
			const hasBefore = !!record.before;

			return value.some(v => {
				switch (upsertMode) {
					case true:
						switch (v) {
							case SetupWizardPreviewStatus.UPSERT:
								return hasAfter && !hasBefore;
							case SetupWizardPreviewStatus.CHANGED:
								return hasAfter && hasBefore;
							case SetupWizardPreviewStatus.UNCHANGED:
								return hasBefore && !hasAfter;
							default:
								return false;
						}
					default:
						switch (v) {
							case SetupWizardPreviewStatus.NEW:
								return hasAfter && !hasBefore;
							case SetupWizardPreviewStatus.CHANGED:
								return hasAfter && hasBefore;
							case SetupWizardPreviewStatus.UNCHANGED:
								return hasBefore && !hasAfter;
							default:
								return false;
						}
				}
			});
		},
	};
}

@Component({
	selector: 'app-setup-wizard-before-after-status',
	imports: [NzTagModule, NzTooltipModule],
	standalone: true,
	templateUrl: './setup-wizard-before-after-status.html',
	styleUrl: './setup-wizard-before-after-status.scss',
})
export class SetupWizardBeforeAfterStatus<T> {
	upsertMode = input<boolean>(false);
	data = input.required<BeforeAfter<T>>();
	SetupWizardPreviewStatus = SetupWizardPreviewStatus;
	public BEFORE_AFTER_STATUS_UPSERT_COLOR = BEFORE_AFTER_STATUS_UPSERT_COLOR;
	public BEFORE_AFTER_STATUS_NEW_COLOR = BEFORE_AFTER_STATUS_NEW_COLOR;
	public BEFORE_AFTER_STATUS_CHANGED_COLOR = BEFORE_AFTER_STATUS_CHANGED_COLOR;
	public BEFORE_AFTER_STATUS_UNCHANGED_COLOR = BEFORE_AFTER_STATUS_UNCHANGED_COLOR;
}
